export default __webpack_public_path__ + "static/media/testi.129a17f2.png";